import React from 'react';

function Footer() {
    return (
        <div style={{
            position: "fixed",
            left: "0",
            bottom: "0",
            width: "100%",
            height: "10%",
            textAlign: "center",
            backgroundColor: "lightblue"
        }}>
        </div>
    );
}

export default Footer;